export const twoFactorAuthCodeLength = 6;
